import { FlexColumnAlignJustifyCenter } from "@/components/Flex";
import { AuthEvent } from "@/features/Auth/AuthPopup/utils/constants";
import Fade from "@mui/material/Fade";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import SignupPopup from "@/features/Auth/SignupPopup";

const BlurredDocumentBgWithSignupCard = ({
    event = AuthEvent.NOTE_EDITOR_FLOATING,
}: {
    event: AuthEvent;
}) => {
    const isScrolledFarEnough = useScrollTrigger({ disableHysteresis: true, threshold: 150 });

    return (
        <Fade in={isScrolledFarEnough} unmountOnExit mountOnEnter>
            <FlexColumnAlignJustifyCenter
                style={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    width: "100vw",
                    overflow: "hidden",
                    zIndex: 1500,
                }}>
                <FlexColumnAlignJustifyCenter
                    style={{
                        height: "100vh",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        backdropFilter: "blur(8px)",
                        WebkitBackdropFilter: "blur(8px)",
                        width: "100%",
                        padding: "0 2rem",
                    }}>
                    <SignupPopup event={event} />
                </FlexColumnAlignJustifyCenter>
            </FlexColumnAlignJustifyCenter>
        </Fade>
    );
};

export default BlurredDocumentBgWithSignupCard;
